// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__Rocpu","container":"NotFound_container__B8K32","error":"NotFound_error__xmpZf","image":"NotFound_image__dA3sI","message":"NotFound_message__4VDFC"};